import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Typography
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export type SubscriptionExpiredDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const SubscriptionExpiredDialog: React.FC<SubscriptionExpiredDialogProps> = ({
  open,
  onClose
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <ErrorOutlineIcon color="error" sx={{ mr: 1, fontSize: 28 }} />
          Subscription Expired
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          <Typography variant="body1" paragraph>
            <strong>Your subscription has expired and access to this team has been suspended.</strong>
          </Typography>
          <Typography variant="body1" paragraph>
            To restore access, please renew your subscription through your organization's billing settings.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            If you believe this is an error, contact your organization administrator.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionExpiredDialog;
